import styled from 'styled-components';
import { BoxCta } from './common/box-cta';
import { SignalInterestInDataButton } from './signal-interest-in-data-button';

interface Props {
  text?: string;
  companyId: string;
}

export function WishToLearnMore(props: Props) {
  const text = props.text
    ? props.text
    : 'Want to see this data? Click the button below and we will let the company know.';
  return (
    <BoxCta title="Ask for this data">
      <p>{text}</p>
      <StyledInterestedButton companyId={props.companyId} />
    </BoxCta>
  );
}

const StyledInterestedButton = styled(SignalInterestInDataButton)`
  margin-top: 10px;
`;
